import { types } from '../types'

const initialState = {
    waitingTransaction: false,
    successTransaction: false,
    errorTransaction: '',
    transactionList: {},

    waitingTransactionPDF: false,
    successTransactionPDF: false,
    errorTransactionPDF: '',
    transactionDF: '',

    waitingAllTransaction: false,
    successAllTransaction: false,
    errorAllTransaction: '',
    transactionAllList: {}

}

const transactionReducer = (state = initialState, { type, action }) => {
    switch (type) {
        case types.TRANSACTION_LIST_REQUEST: {
            return {
                ...state,
                waitingTransaction: true,
                successTransaction: false,
                errorTransaction: '',
                transactionList: {}
            }
        }
        case types.TRANSACTION_LIST_SUCCESS: {
            return {
                ...state,
                waitingTransaction: false,
                successTransaction: true,
                transactionList: action.data,
            }
        }
        case types.TRANSACTION_LIST_ERROR: {
            return {
                ...state,
                waitingTransaction: false,
                errorTransaction: action.error,
            }
        }
        case types.TRANSACTION_RESET_PROPS: {
            return {
                ...state,
                waitingTransaction: false,
                successTransaction: false,
                errorTransaction: '',
                transactionDF: ''
            }
        }
        //********************************************************************************************* */
        case types.TRANSACTION_PDF_REQUEST: {
            return {
                ...state,
                waitingTransactionPDF: true,
                successTransactionPDF: false,
                errorTransactionPDF: '',
                transactionList: []
            }
        }
        case types.TRANSACTION_PDF_SUCCESS: {
            return {
                ...state,
                waitingTransactionPDF: false,
                successTransactionPDF: true,
                transactionDF: action.data
            }
        }
        case types.TRANSACTION_PDF_ERROR: {
            return {
                ...state,
                waitingTransactionPDF: false,
                errorTransactionPDF: action.error,
            }
        }
        case types.TRANSACTION_PDF_RESET_PROPS: {
            return {
                ...state,
                waitingTransactionPDF: false,
                successTransactionPDF: false,
                errorTransactionPDF: '',
                transactionDF: ''
            }
        }
        //******************************************************************************************** */
        case types.TRANSACTION_LIST_ADMIN_REQUEST: {
            return {
                ...state,
                waitingAllTransaction: true,
                successAllTransaction: false,
                errorAllTransaction: '',
            }
        }
        case types.TRANSACTION_LIST_ADMIN_SUCCESS: {
            return {
                ...state,
                waitingAllTransaction: false,
                successAllTransaction: true,
                transactionAllList: action.data,
            }
        }
        case types.TRANSACTION_LIST_ADMIN_ERROR: {
            return {
                ...state,
                waitingAllTransaction: false,
                errorAllTransaction: action.error,
            }
        }
        case types.TRANSACTION_ADMIN_RESET_PROPS: {
            return {
                ...state,
                waitingAllTransaction: false,
                successAllTransaction: false,
                errorAllTransaction: '',
                transactionAllList: {}
            }
        }

        default:
            return state
    }
}


export default transactionReducer;